module.exports = __webpack_public_path__ + "img/pocket_bag_length.7662f52b.png";